import $ from 'jquery';
import 'spectrum-colorpicker';
import 'spectrum-colorpicker/spectrum.css';
const ELEMENT_SELECTOR = '.js__colorpicker-init';
const COLOR_VALUE_INPUT_SELECTOR = '.js__color-value-input';
export class ColorPicker {
    static init($root = $('body')) {
        const $colorPicker = $root.find(ELEMENT_SELECTOR);
        if (!$colorPicker.length) {
            return;
        }
        $colorPicker.each((index, element) => {
            const $element = $(element);
            const $input = $element.parent().find(COLOR_VALUE_INPUT_SELECTOR);
            $element.spectrum({
                change: function (color) {
                    $input.val(color.toHexString());
                },
                preferredFormat: 'hex',
                color: $input.val(),
                showInitial: true,
                showInput: true,
            });
            $input.on('change', e => {
                const $input = $(e.currentTarget);
                $element.spectrum('set', $input.val());
            });
        });
    }
}
